import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { CardNumberElement, useElements, useStripe } from '@stripe/react-stripe-js';

import { CheckoutFormComponent } from './CheckoutFormComponent';
import { Results } from '../constants';
import stores from '../../../../stores';

const CheckoutFormContainer = ({
  onClose, setResult, setSent, schoolName, cost,
}) => {
  const stripe = useStripe();
  const elements = useElements();

  const [isSending, setIsSending] = useState(false);
  const [error, setError] = useState(null);
  const [isCardNumberReady, setCardNumberReady] = useState(false);
  const [isCardExpiryReady, setCardExpiryReady] = useState(false);
  const [isCardCvcReady, setCardCvcReady] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setIsSending(true);

    const cardElement = elements.getElement(CardNumberElement);
    const clientSecret = stores.theoryAccessStore.paymentData.client_secret;
    const { prenom: name, nom: surname } = stores.userStore.userInfo;

    const result = await stripe.confirmCardPayment(clientSecret, {
      payment_method: {
        card: cardElement,
        billing_details: {
          name: `${name} ${surname}`,
        },
      },
    });

    setIsSending(false);

    if (result.error) {
      setError(result.error.message);
    } else if (result.paymentIntent.status === 'succeeded') {
      setResult(Results.Success);
      setSent();
    }
  };

  const isFormReady = isCardNumberReady && isCardExpiryReady && isCardCvcReady;

  return (
    <CheckoutFormComponent
      onClose={onClose}
      schoolName={schoolName}
      isSending={isSending}
      stripe={stripe}
      handleSubmit={handleSubmit}
      cost={cost}
      error={error}
      setCardNumberReady={setCardNumberReady}
      setCardExpiryReady={setCardExpiryReady}
      setCardCvcReady={setCardCvcReady}
      isFormReady={isFormReady}
    />
  );
};

CheckoutFormContainer.propTypes = {
  onClose: PropTypes.func.isRequired,
  setResult: PropTypes.func.isRequired,
  setSent: PropTypes.func.isRequired,
  schoolName: PropTypes.string.isRequired,
  cost: PropTypes.string.isRequired,
};

export { CheckoutFormContainer };
